<template>
    <div>    
        <el-form ref="form" :model="survey_info" class="main_form" v-if="survey_info.length > 0">
            <template v-for="item in survey_info">
                <div :key="item.id">
                    <!-- <el-form-item :label="item.category" class="main_form_category"></el-form-item>
                    <template v-for="sub_item in item.sub_category">
                        <div :key="sub_item" class="sub_category">
                            <div class="sub_category_desc"><span>>> {{ sub_item.sub_category_desc }}</span></div>
                            <template v-for="sj in sub_item.subject"> -->

                                    <el-form-item :label="item.desc" class="subject_info">
                                        <!-- <div style="text-align:left;"><span>{{ sj.subject_desc_sub }}</span></div> -->
                                        <!-- <span slot="label" v-if="!sj.selected_option && error_flag" style="color:red;"><span style="font-weight:bold;">{{ sj.subject_desc_main }}</span> ：{{ sj.subject_desc_sub }}</span>
                                        <span slot="label" v-if="(sj.selected_option && error_flag) || !error_flag"><span style="font-weight:bold;">{{ sj.subject_desc_main }}</span> ：{{ sj.subject_desc_sub }}</span> -->
                                    </el-form-item>
                                    <div class="option_info" v-if="item.choice_type=='单选'">
                                        <template v-for="option in item.options">   
                                            <el-radio :key="option" v-model="item.selected_option" :label="option" v-if="item.selected_option=='' && error_flag_survey" style="color:red;">{{ option }}</el-radio>
                                            <el-radio :key="option" v-model="item.selected_option" :label="option" v-if="(item.selected_option!='' && error_flag_survey) || !error_flag_survey">{{ option }}</el-radio>
                                        </template>
                                    </div>
                                    <div class="option_info_checkbox" v-if="item.choice_type=='多选'">
                                        <el-checkbox-group v-model="item.selected_option">
                                        <template v-for="option in item.options">   
                                            <el-checkbox :key="option" :label="option" v-if="item.selected_option=='' && error_flag_survey" style="color:red;display:block;padding-top:10px;">{{ option }}</el-checkbox>
                                            <el-checkbox :key="option" :label="option" v-if="(item.selected_option!='' && error_flag_survey) || !error_flag_survey" style="display:block;padding-top:10px;">{{ option }}</el-checkbox>
                                        </template>
                                        </el-checkbox-group>
                                        <div :key="item.proof_desc" class="proof_area" v-show="item.selected_option.includes('其他')">
                                            <el-input
                                                type="textarea"
                                                resize="none"
                                                :placeholder="item.other_desc"
                                                :rows="3"
                                                v-model="item.proof"
                                                v-if="item.proof=='' && error_flag_survey"
                                                style="border:2px solid red;">
                                            </el-input>
                                            <el-input
                                                type="textarea"
                                                resize="none"
                                                :placeholder="item.other_desc"
                                                :rows="3"
                                                v-model="item.proof"
                                                v-if="(item.proof!='' && error_flag_survey) || !error_flag_survey">
                                            </el-input>
                                        </div>
                                    </div>

                            <!-- </template>
                        </div>
                    </template> -->
                </div>
            </template>
            <!-- <el-form-item label="举证说明" class="main_form_category"></el-form-item>
            <template v-for="item in proof_info">
                <div :key="item.proof_desc" class="proof_area">
                    <el-form-item :label="item.proof_desc"></el-form-item>
                    <el-input
                        type="textarea"
                        resize="none"
                        :placeholder="item.proof_default"
                        :rows="4"
                        v-model="item.proof">
                        <span slot="placeholder">{{ item.proof_default }}</span>
                    </el-input>
                </div>
            </template> -->
        </el-form>
        <!-- <div v-if="question_info.length <= 0" class="no_ques">暂无问卷信息，请先导入。</div> -->
        <div v-if="display_flag===true" class="no_ques" v-cloak>暂无调研信息，请先导入。</div>
    </div>   
</template>

<script>
import postdata from "@/api/postData.js";
// import getdata from "@/api/getData.js";
export default {
    // 组件传递的prop数据，会在beforeUpdate钩子期间生效！
    beforeUpdate() {
        if(this.survey_info.length <= 0){
            this.display_flag = true;
        }else{
            this.display_flag = false;
        }
    },
    data() {
        return {
            template_file: {
                file_name: 'survey-import_template.xlsx'
            },
            formInline: {
                search_info: '',
                search_result: [],
            },
            display_flag: false,
            // 这里直接使用父组件传递的问卷信息，即下面props中的数据
        }
    },
    // props: ['send_id', 'send_type'],
    props: ['survey_info', 'error_flag_survey'],
    methods: {
        Download_template() {
            postdata.downloadFiles("download", JSON.stringify(this.template_file))
              .then(resp => {
                // 将流文件通过浏览器下载，这里使用整个后台返回的response，供download函数提取data、headers等信息
                this.download(resp);
              })
              .catch(err => {
                console.log(err);
              })
        },
        download (res) {
            let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });//type是文件类，详情可以参阅blob文件类型
            // 创建新的URL并指向File对象或者Blob对象的地址
            const blobURL = window.URL.createObjectURL(blob)
            // 创建a标签，用于跳转至下载链接
            const tempLink = document.createElement('a')
            tempLink.style.display = 'none'
            tempLink.href = blobURL
            tempLink.setAttribute('download', decodeURI(res.headers['content-disposition'].split(';')[1].split('=')[1]))
            // 兼容：某些浏览器不支持HTML5的download属性
            if (typeof tempLink.download === 'undefined') {
                tempLink.setAttribute('target', '_blank')
            }
            // 挂载a标签
            document.body.appendChild(tempLink)
            tempLink.click()
            document.body.removeChild(tempLink)
            // 释放blob URL地址
            window.URL.revokeObjectURL(blobURL)
        },
        // 向父组件传递问卷测评结果（包括选择题和举证题两部分）
        submitManaSurvey() {
            // console.log('send data to father component.');
            this.$emit('sendData', this.survey_info);
        },
        
    }
}
</script>

<style scoped>
[v-cloak]{
    display: none !important;
}
.dialog_form /deep/ .el-input {
    width: 223.67px;
}
::v-deep .el-form-item {
    margin-bottom: 0;
}
.main_form {
    padding: 20px;
    /* min-width: 1900px; */
}
.main_form_div {
    /* background: #f5f7fa; */
    margin-bottom: 25px;
}
.main_form_div /deep/ .el-form-item__label {
    font-size: 16px;
    line-height: 30px;
    color: #409EFF;
}
.main_form_category {
    border-left: solid 8px #409EFF;
    padding-left: 15px;
    font-weight: bold;
    margin-bottom: 10px;
}
.main_form_category /deep/ .el-form-item__label {
    font-size: 16px;
    line-height: 30px;
    color: #409EFF;
}
.sub_category {
    border: 1.3px solid #E4E7ED;
    margin-bottom: 10px;
}
.sub_category_desc {
    text-align: left;
    margin-bottom: 10px;
    padding: 8px;
    font-size: 16px;
    font-weight: bold;
    color: #606266;
}
.subject_info {
    /* background: #cee4f1; */
    background: #f8f8f8;
    /* opacity: 0.4; */
    padding-left: 10px;
    margin-bottom: 2px;
}
.subject_info /deep/ .el-form-item__label {
    /* width: 75%; */
    text-align: left;
    color: #606266;
    font-size: 14px;
    line-height: 40px;
}
/* .subject_info /deep/ .el-form-item__content {
    width: 650px;
    float: right;
} */
.option_info {
    text-align: left;
    height: 35px;
    line-height: 35px;
    margin-left: 30px;
}
.option_info_checkbox {
    text-align: left;
    margin-left: 30px;
    margin-bottom: 10px;
}
.proof_area {
    margin-top: 10px;
}
.proof_area /deep/ .el-form-item__label {
    font-size: 15px;
    color: #606266;
}
.no_ques {
  width: 100%;
  margin: 0 auto;
  color: #909399;
  font-weight: bold;
  height: 60px;
  line-height: 60px;
  margin-top: 20px;
}
</style>